import React, { useEffect, useState } from 'react';
import './styles.css';
import Card from '../Card';
import { FetchItemsFn, Item, ListScope, UiColumn, UiColumn2 } from '../ItemList/types';
import type { ICellRendererParams, IGetRowsParams } from "ag-grid-community";
import axios from "axios";
import UserSettings from '../UserSettings/userSettingsOdmraz';
import ProfilePopup from '../ProfilePopup';
import useAppData from '@/store/useAppData';
import ItemListOdmraz from '../ItemList/itemListOdmraz';
import DeicingList from '../DeicingList';
import { DeicingItem } from '../DeicingList/types';
import DeicingListCheck from '../DeicingListCheck';
import DeicingDashboard from '../DeicingDashboard';

const ItemListCardOdmraz = () => {

    const setDisplaySettings = useAppData(state => state.setDisplaySettings);
    const displaySettings = useAppData(state => state.displaySettings);
    const selectedStock = useAppData(state => state.selectedStock);
    const [profileOpen, setProfileOpen] = useState(false);
    const [scopeState, setScopeState] = React.useState<ListScope>("all");
    const [expanded, setExpanded] = useState<Set<string>>(new Set());
    const loggedUser = useAppData(state => state.user);

    useEffect(() => {
        if (selectedStock?.main) {
            setScopeState("all");
        } else {
            if (loggedUser?.userrole === "operator" || loggedUser?.userrole === "admin") {
                setScopeState("deicingOperator");
            } else if (loggedUser?.userrole === "kontrola") {
                setScopeState("deicingCheck");
            }
        }
    }, [selectedStock]);

    const TreeCellRenderer = (
        params: ICellRendererParams<any>
    ) => {
        const row = params.data;

        if (!row) {
            return null;
        }

        const expandable =
            row.type === "date" ||
            row.type === "flight";

        const isExpanded = expanded.has(row.treeId);

        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: row.level * 24,
                    gap: 6
                }}
            >
                {expandable && (
                    <span
                        onClick={event => {
                            event.stopPropagation();
                            toggleNode(row.treeId);
                        }}
                        style={{
                            cursor: "pointer",
                            width: 18,
                            userSelect: "none"
                        }}
                    >
                        {isExpanded ? "▼" : "▶"}
                    </span>
                )}

                {!expandable && (
                    <span style={{ width: 18 }} />
                )}

                <span>{row.label}</span>
            </div>
        );
    };

    const toggleNode = (id: string) => {
        setExpanded(prev => {
            const next = new Set(prev);

            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }

            return next;
        });
    };

    const columnsFluids: UiColumn<Item>[] = [
        { field: "id", headerName: "Id", flex: 0.5, filter: "number", floatingFilter: true },
        { field: "name", headerName: "Název", flex: 3, filter: "text", floatingFilter: true },
        { field: "quantity", headerName: "Počet", flex: 1, filter: "number", floatingFilter: true/*, editable: scopeState === "allItems" && loggedUser?.userrole === "admin"*/ }
    ];

    const columnsDeicingGrouped: UiColumn<DeicingItem>[] = [
        {
            headerName: "Datum | Let | Vozidlo",
            // flex: 1.7,
            minWidth: 200,
            cellRenderer: TreeCellRenderer
        },
        // {
        //     //colId: "group",
        //     headerName: "Datum / let",
        //     minWidth: 220,
        //     flex: 1.5,

        //     cellRenderer: (params: any) => {
        //         const row = params.data;

        //         if (row.rowType === "dateGroup") {
        //             return (
        //                 <strong>
        //                     {dateFormat(row.date, true)}
        //                 </strong>
        //             );
        //         }

        //         if (row.rowType === "flightGroup") {
        //             return (
        //                 <div style={{ paddingLeft: 20, fontWeight: 600 }}>
        //                     ✈ {row.flightNumber}
        //                 </div>
        //             );
        //         }

        //         return null;
        //     },
        // },
        // {
        //     field: "date",
        //     headerName: "Datum",
        //     flex: 0.8,
        //     minWidth: 80,
        //     filter: "text",
        //     floatingFilter: true,
        //     valueFormatter: params => {
        //         if (!params.value) return "";

        //         return dateFormat(params.value, true);
        //     }
        // },
        // {
        //     field: "stockName",
        //     headerName: "Vozidlo",
        //     flex: 1,
        //     minWidth: 120,
        //     filter: "text",
        //     floatingFilter: true,
        // },
        {
            field: "type1Start",
            headerName: "Začátek I",
            // flex: 1,
            minWidth: 115,
            filter: "text",
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return dateFormat(params.value);
            }
        },
        {
            field: "type1End",
            headerName: "Konec I",
            // flex: 1,
            minWidth: 115,
            filter: "text",
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return dateFormat(params.value);
            }
        },
        {
            field: "type1FluidConsumption",
            headerName: "Kapalina I",
            // flex: 0.8,
            minWidth: 80,
            filter: "number",
            floatingFilter: true,
        },
        {
            field: "fluidRatio",
            headerName: "Poměr I",
            // flex: 0.8,
            minWidth: 80,
            filter: "number",
            floatingFilter: true,
        },
        {
            field: "type2Start",
            headerName: "Začátek II",
            // flex: 1,
            minWidth: 120,
            filter: "text",
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return dateFormat(params.value);
            }
        },
        {
            field: "type2End",
            headerName: "Konec II",
            // flex: 1,
            minWidth: 120,
            filter: "text",
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return dateFormat(params.value);
            }
        },
        {
            field: "type2FluidConsumption",
            headerName: "Kapalina II",
            // flex: 0.8,
            minWidth: 80,
            filter: "number",
            floatingFilter: true,
        },
        {
            field: "waterConsumption",
            headerName: "Voda",
            // flex: 0.8,
            minWidth: 80,
            filter: "number",
            floatingFilter: true,
        },
        // {
        //     field: "company",
        //     headerName: "Společnost",
        //     flex: 1.2,
        //     minWidth: 120,
        //     filter: "text",
        //     floatingFilter: true,
        // },
        // {
        //     field: "flightNumber",
        //     headerName: "Číslo letu",
        //     flex: 1,
        //     minWidth: 120,
        //     filter: "text",
        //     floatingFilter: true,
        // },
        {
            field: "checked",
            headerName: "Kontrola",
            // flex: 0.7,
            minWidth: 70,
            filter: "set",
            floatingFilter: true,
            valueFormatter: params => params.value ? "Ano" : "Ne"
        }
    ];

    //   date?: string | null;
    //   type1Start?: number | null;
    //   type1End?: number | null;
    //   type2Start?: number | null;
    //   type2End?: number | null;
    //   notes?: string | null;
    //   type1FluidConsumption?: number | null;
    //   type2FluidConsumption?: number | null;
    //   waterConsumption?: number | null;
    //   deice1?: string | null;
    //   deice2?: string | null;
    //   deice3?: string | null;
    //   operator1?: string | null;
    //   operator2?: string | null;
    //   operator3?: string | null;
    //   checkedBy?: string | null;
    //   stand?: number | null;
    //   company?: number | null;
    //   aircraftType?: string;
    //   aircraftRegistration?: string;
    //   flightNumber?: string;
    //   oat?: number | null;
    //   wingTemperature?: number | null;
    //   weatherCode?: string;

    const columnsDeicing: UiColumn<DeicingItem>[] = [
        {
            field: "date",
            headerName: "Datum",
            // flex: 0.8,
            minWidth: 60,
            maxWidth: 150,
            filter: "text",
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return dateFormat(params.value, true);
            }
        },
        {
            field: "type1Start",
            headerName: "Začátek odmrazování",
            // flex: 1,
            minWidth: 115,
            filter: "text",
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return dateFormat(params.value);
            }
        },
        {
            field: "type1End",
            headerName: "Konec odmrazování",
            // flex: 1,
            minWidth: 115,
            filter: "text",
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return dateFormat(params.value);
            }
        },
        {
            field: "deicingDuration",
            headerName: "Čas odmrazení",
            // flex: 1,
            minWidth: 115,
            filter: "text",
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return dateFormat(params.value, false, true);
            }
        },
        {
            field: "stand",
            headerName: "Stojánka",
            // flex: 1,
            minWidth: 80,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "aircraftType",
            headerName: "Typ letadla",
            // flex: 1,
            minWidth: 80,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "aircraftRegistration",
            headerName: "Imatrikulace letadla",
            // flex: 1,
            minWidth: 80,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "flightNumber",
            headerName: "Číslo letu",
            // flex: 1,
            minWidth: 80,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "companyName",
            headerName: "Společnost",
            // flex: 1.2,
            minWidth: 80,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "type1FluidConsumption",
            headerName: "Spotřeba kapaliny typ I",
            // flex: 0.8,
            minWidth: 250,
            filter: "number",
            floatingFilter: true,
        },
        {
            field: "fluid1Ratio",
            headerName: "Poměr kapaliny v %",
            // flex: 0.8,
            minWidth: 200,
            filter: "number",
            floatingFilter: true,
        },
        {
            field: "type2FluidConsumption",
            headerName: "Spotřeba kapaliny typ II",
            // flex: 0.8,
            minWidth: 250,
            filter: "number",
            floatingFilter: true,
        },
        {
            field: "waterConsumption",
            headerName: "Spotřeba vody",
            // flex: 0.8,
            minWidth: 200,
            filter: "number",
            floatingFilter: true,
        },
        {
            field: "oat",
            headerName: "OAT",
            // flex: 1,
            minWidth: 30,
            maxWidth: 150,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "wingTemperature",
            headerName: "Teplota křídel",
            // flex: 1,
            minWidth: 30,
            maxWidth: 150,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "weatherName",
            headerName: "Počasí",
            // flex: 1,
            minWidth: 80,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "notes",
            headerName: "Poznámky",
            // flex: 1,
            minWidth: 80,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "most",
            headerName: "Most",
            // flex: 1,
            maxWidth: 120,
            filter: "text",
            floatingFilter: true,
            valueFormatter: params => {
                if (!params.value) return "";

                return !!params.value ? "Ano" : "Ne";
            }
        },
        {
            field: "deice1",
            headerName: "Vozidlo 1",
            // flex: 1,
            minWidth: 100,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "deice2",
            headerName: "Vozidlo 2",
            // flex: 1,
            minWidth: 100,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "deice3",
            headerName: "Vozidlo 3",
            // flex: 1,
            minWidth: 100,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "checkedBy",
            headerName: "Sluchátka",
            // flex: 1,
            minWidth: 100,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "operator1",
            headerName: "Pracovník 1",
            // flex: 1,
            minWidth: 100,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "operator2",
            headerName: "Pracovník 2",
            // flex: 1,
            minWidth: 100,
            filter: "text",
            floatingFilter: true,
        },
        {
            field: "operator3",
            headerName: "Pracovník 3",
            // flex: 1,
            minWidth: 100,
            filter: "text",
            floatingFilter: true,
        },
        // {
        //     field: "checked",
        //     headerName: "Kontrola",
        //     flex: 0.7,
        //     minWidth: 70,
        //     filter: "set",
        //     floatingFilter: true,
        //     valueFormatter: params => params.value ? "Ano" : "Ne"
        // }
    ];

    const columns = scopeState === "all" ? columnsFluids : scopeState === "allItemsGrouped" ? columnsDeicingGrouped : columnsDeicing;

    // const dateFormat = (date: string, dateOnly?: boolean, timeOnly?: boolean) => {
    //     const d = new Date(date);

    //     const pad = (n: number) => String(n).padStart(2, "0");

    //     if (dateOnly) {
    //         return (
    //             pad(d.getDate()) + "." +
    //             pad(d.getMonth() + 1) + "." +
    //             d.getFullYear()
    //         );
    //     } else if (timeOnly) {
    //         return (pad(d.getHours()) + ":" +
    //             pad(d.getMinutes()));
    //     } else {
    //         return (
    //             pad(d.getDate()) + "." +
    //             pad(d.getMonth() + 1) + "." +
    //             d.getFullYear() + " " +
    //             pad(d.getHours()) + ":" +
    //             pad(d.getMinutes()) + ":" +
    //             pad(d.getSeconds())
    //         );
    //     }
    // };

    const dateFormat = (
        date?: string | number | null,
        dateOnly?: boolean,
        timeOnly?: boolean
    ) => {
        if (date == null) return "";

        const pad = (n: number) => String(n).padStart(2, "0");

        // number = počet minut
        if (timeOnly) {
            const hours = Math.floor(Number(date) / 60);
            const minutes = Number(date) % 60;

            return `${pad(hours)}:${pad(minutes)}`;
        }

        const d = new Date(date);

        if (Number.isNaN(d.getTime())) return "";

        if (dateOnly) {
            return `${pad(d.getUTCDate())}.${pad(d.getUTCMonth() + 1)}.${d.getUTCFullYear()}`;
        }

        return (
            `${pad(d.getUTCDate())}.${pad(d.getUTCMonth() + 1)}.${d.getUTCFullYear()} ` +
            `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`
        );
    };

    const fetchItems: FetchItemsFn<Item> = async ({ startRow, endRow, agParams }) => {

        if (scopeState === "all") {
            const { rows, totalCount } = await getStockItems(startRow, endRow, { ...agParams });
            // const rowsWithoutContainer = rows.filter(row => row.name != "IBC kontejner");
            return { rows, totalCount };
        } else if (scopeState === "allItems") {
            const { rows, totalCount } = await getDeicings(startRow, endRow, true, { ...agParams });
            return { rows, totalCount };
        } else if (scopeState === "allItemsGrouped") {
            const { rows, totalCount } = await getDeicings(startRow, endRow, false, { ...agParams });
            return { rows, totalCount };
        }

        return { rows: [], totalCount: 0 };
    };

    const getStockItems = async (startRow, endRow, agParams) => {
        try {
            console.log(agParams);
            const res = await (
                axios({
                    method: "post",
                    url: "api/stockItem/getAll",
                    data: {
                        start: startRow,
                        end: endRow,
                        stockId: agParams.stockId,
                        filterModel: agParams.filterModel,
                        sortModel: agParams.sortModel,
                        withoutQuantity: agParams?.withoutQuantity
                    }
                })
            );

            return {
                rows: res.data.stocksItems,
                totalCount: res.data.totalCount
            };
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const getDeicings = async (startRow, endRow, withFluids, agParams) => {
        try {
            console.log(agParams);
            const res = await (
                axios({
                    method: "post",
                    url: "api/deicing/getAll",
                    data: {
                        start: startRow,
                        end: endRow,
                        withFluids
                        // filterModel: agParams.filterModel,
                        // sortModel: agParams.sortModel,
                    }
                })
            );

            return {
                rows: res.data.deicingItems,
                totalCount: res.data.totalCount
            };
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const onClickSettings = () => {
        setDisplaySettings(true);
    };

    const onChangedScope = (scope: ListScope) => {
        setScopeState(scope);
    };

    return <>
        {displaySettings && (
            <div className="inv-modal-overlay1" onMouseDown={() => setDisplaySettings(false)}>
                <div
                    className="inv-modal1"
                    onMouseDown={(e) => e.stopPropagation()}
                    role="dialog"
                    aria-modal="true"
                >
                    <UserSettings></UserSettings>
                </div>
            </div>
        )}
        {profileOpen && (
            <ProfilePopup onClose={() => setProfileOpen(false)} />
        )}
        {!displaySettings && selectedStock?.main && scopeState === "deicingDashboard" ? <Card
            title="Hlavní sklad"
            onSettingsClick={onClickSettings}
            onProfileClick={() => setProfileOpen(true)}
        ><DeicingDashboard onChangedScope={onChangedScope} /></Card> : !displaySettings && selectedStock?.main ? scopeState === "allItems" || scopeState === "allItemsGrouped" ? <div className="deicing"><Card
            title="Hlavní sklad"
            onSettingsClick={onClickSettings}
            onProfileClick={() => setProfileOpen(true)}
        >
            <ItemListOdmraz
                columns={columns}
                fetchItems={fetchItems}
                rowSelectionMode={scopeState === "allItems"}
                onChangedScope={onChangedScope}
                scope={scopeState}
                expanded={expanded}
                toggleNode={toggleNode}
            />
        </Card></div> :
            <Card
                title="Hlavní sklad"
                onSettingsClick={onClickSettings}
                onProfileClick={() => setProfileOpen(true)}
            >
                <ItemListOdmraz
                    columns={columns}
                    fetchItems={fetchItems}
                    rowSelectionMode={false}
                    onChangedScope={onChangedScope}
                    scope={scopeState}
                    expanded={expanded}
                    toggleNode={toggleNode}
                />
            </Card>
            : scopeState === "deicingCheck" ? <DeicingListCheck
                onSettingsClick={onClickSettings}
                onProfileClick={() => setProfileOpen(true)}
                onChangedScope={onChangedScope}
                scope={scopeState}

            ></DeicingListCheck> :
                <DeicingList
                    onSettingsClick={onClickSettings}
                    onProfileClick={() => setProfileOpen(true)}
                    onChangedScope={onChangedScope}
                    scope={scopeState}
                >
                </DeicingList>}</>;
};

export default ItemListCardOdmraz;
